import styled from "styled-components";

export const TopBarStyle = styled.div`
  .top-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f28809;
    padding: 10px 20px;
    height: 10vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    width: 100%;
    font-family: medium-pro, sans-serif;
  }
  .top-container2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f28809;
    padding: 10px 20px;
    height: 10vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    font-family: medium-pro, sans-serif;
  }
  .container-1 {
    display: flex;
    align-item: center;
  }
  .container-2 {
    display: flex;
    align-item: center;
  }

  .person {
    margin-top: 6px;
  }
  .space {
    margin-right: 2vh;
  }
  .space-large {
    margin-right: 8vh;
  }
  .container-2 {
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .logo2 {
    width: 20vh;
    height: 6vh;
    cursor: pointer;
  }

  .logout-style {
    color: white;
    font-size: 1.8rem;
    cursor: pointer;
  }

  .reload-icon-style {
    color: white;
    font-size: 1.8rem;
    cursor: pointer;
  }

  .demo-icon-style {
    color: white;
    font-size: 1.7rem;
    cursor: pointer;
  }

  .discount-icon-style {
    width: 1.8rem;
    height: 1.8rem;
    cursor: pointer;
  }

  .add-user {
    color: white;
    font-size: 35px;
    cursor: pointer;
  }

  .text-topbar {
    color: white;
    margin-top: 0;
    margin-bottom: 0;
    font-family: medium-pro, sans-serif;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .dropDownVisible {
    display: none;
  }

  .dotStyles {
    color: white;
    font-size: 23px;
  }

  .droptext {
    font-family: light-pro, sans-serif;
    font-size: 15px;
  }

  /* For large devices */
  @media screen and (max-width: 2560px) {
    .logout-style {
      font-size: 2.3rem;
    }

    .text-topbar {
      font-size: 2.3rem;
    }
    .discount-icon-style {
      width: 2.3rem;
      height: 2.3rem;
    }

    .reload-icon-style {
      font-size: 2.3rem;
    }
    .demo-icon-style {
      font-size: 1.8rem;
    }
  }

  @media screen and (max-width: 1500px) {
    .logout-style {
      font-size: 1.8rem;
    }

    .text-topbar {
      font-size: 1.8rem;
    }
    .discount-icon-style {
      width: 1.8rem;
      height: 1.8rem;
    }

    .reload-icon-style {
      font-size: 1.8rem;
    }
    .demo-icon-style {
      font-size: 1.7rem;
    }
  }
  @media screen and (max-width: 1024px) {
    .logo2 {
      height: 7vh;
    }

    .logout-style {
      font-size: 1.5rem;
    }

    .discount-icon-style {
      width: 1.5rem;
      height: 1.5rem;
    }

    .reload-icon-style {
      font-size: 1.5rem;
    }
    .demo-icon-style {
      font-size: 1.4rem;
    }
  }
  /* For medium devices */
  @media only screen and (max-width: 768px) {
    .logo2 {
      width: 100px;
      height: 40px;
    }

    .logout-style {
      color: white;
      font-size: 1.5rem;
      cursor: pointer;
    }

    .reload-icon-style {
      font-size: 1.5rem;
    }
    .demo-icon-style {
      font-size: 1.4rem;
    }
    .add-user {
      color: white;
      font-size: 30px;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 576px) {
    .text-topbar {
      display: none;
    }
    .top-container2 {
      justify-content: center;
    }

    .dropDownVisible {
      display: block;
    }
    .add-user {
      display: none;
    }

    .reload-icon-style {
      display: none;
    }
    .demo-icon-style {
      display: none;
    }
    .discount-icon-style {
      display: none;
    }

    .logout-style {
      display: none;
    }
  }
  /* For small devices */
  @media screen and (max-width: 350px) {
    .top-container2 {
      justify-content: center;
    }
    .text-topbar {
      display: none;
    }
    .add-user {
      display: none;
    }

    .reload-icon-style {
      display: none;
    }
    .demo-icon-style {
      display: none;
    }

    .discount-icon-style {
      display: none;
    }

    .logout-style {
      display: none;
    }
  }
`;
